<template>
  <HgAmadeusHotelTourSearch
    :is-mobile="isMobile"
    :is-loading-destinations="isLoading"
    :destinations="orderedDestinations"
    :ibe-url="searchUrl"
    :showRooms="['de', 'at'].includes($i18n.locale)"
    :show-cooperation="showCooperation"
    :theme="theme"
    @onUpdateDestinationTerm="updateDestinationTerm"
    @onUpdateSearchParameters="updateSearchParameters"
  />
</template>

<script>
import { HgTravelersLocales } from "@holidayguru/holidayguru-components"
import autosuggestAmadeusQuery from "../../../apollo/queries/amadeus/suggest.gql"
import amadeusHotelSearchUrlQuery from "../../../apollo/queries/ibe/amadeusHotelSearchUrl.gql"

export default {
  data: () => ({
    destinationTerm: "",
    isLoading: false,
    orderedDestinations: [],
    searchUrl: "",
    isMobile: false
  }),
  props: {
    showCooperation: {
      type: Boolean,
      default: false
    },
    theme: {
      type: String,
      default: null
    }
  },
  created() {
    this.isMobile = window.innerWidth < 768

    setInterval(() => {
      let mobilePortal = document.querySelector("#mobile-portal")

      if (mobilePortal != null) {
        mobilePortal.classList.add("holidayguru")
      }
    }, 1000)
  },
  mounted() {
    if (this.theme == "bild") {
      HgTravelersLocales.de.travelerSupportTel = "+49 2301 94580604"
    }
  },
  methods: {
    updateDestinationTerm(term) {
      this.destinationTerm = term
      this.queryDestinations()
    },
    async queryDestinations() {
      if (this.destinationTerm === "") return

      try {
        const {
          data: { autosuggestAmadeus }
        } = await this.$apollo.query({
          query: autosuggestAmadeusQuery,
          variables: {
            search: this.destinationTerm
          }
        })

        if (autosuggestAmadeus && autosuggestAmadeus.length > 0) {
          const orderTypes = []

          autosuggestAmadeus.forEach(elem => {
            if (!orderTypes.includes(elem.type)) {
              orderTypes.push(elem.type)
            }
          })

          // Order results by types
          const ordered = []

          orderTypes.forEach(element => {
            ordered.push(
              autosuggestAmadeus.filter(elem => {
                return elem.type === element
              })
            )
          })

          this.orderedDestinations = [].concat(...ordered)
        }
      } catch (e) {
        console.error(e.graphQLErrors)
      }
    },
    async updateSearchParameters(params) {
      const { destination, dateRange, duration, travelers } = params

      if (dateRange == null || duration == null || travelers == null) {
        return
      }

      if (destination != null) {
        delete destination.__typename
        delete destination.villageName
        delete destination.provinceName
        delete destination.countryName
        delete destination.destinationName
      }

      try {
        const {
          data: { amadeusHotelSearchUrl }
        } = await this.$apollo.query({
          query: amadeusHotelSearchUrlQuery,
          variables: {
            input: {
              startDate: dateRange.start,
              endDate: dateRange.end,
              room: travelers.rooms,
              agesOfChildren: travelers.ages,
              numberOfAdults: travelers.adults,
              destination
            }
          }
        })

        this.searchUrl = amadeusHotelSearchUrl
      } catch (e) {
        console.error(e.graphQLErrors)
      }
    }
  }
}
</script>
